import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { ApiService } from '../../apiservice/apiservice.service';
import { Observable } from 'rxjs';

export interface IHooplaItem {
  id: number;
  availability: string;
  availableCopies: number;
  totalCopies: number;
  holdsInQueue: number;
  isCheckedOut: boolean;
  isReserved: boolean;
  isReadyForPickup: boolean;
  downloadLink: string;
  hasAccount: boolean;
  status: HOOPLA_ITEM_STATUS;
}

export enum HOOPLA_ITEM_STATUS {
  BORROW = 'BORROW',
  HOLD = 'HOLD',
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum HOOPLA_TYPE {
  FLEX = 'FLEX',
  INSTANT = 'INSTANT',
}

@Injectable({
  providedIn: 'root',
})
export class HooplaService {
  private _hooplaUrl: string;

  constructor(
    private _configService: ConfigService,
    private _apiService: ApiService,
  ) {
    this._hooplaUrl = `${this._configService.agApi}/econtent/hoopla`;
  }

  placeHold(contentId: number): Observable<void> {
    return this._apiService.post(`${this._hooplaUrl}/${contentId}/placeHold`, null);
  }

  cancelHold(contentId: number): Observable<void> {
    return this._apiService.delete(`${this._hooplaUrl}/${contentId}/removeHold`);
  }

  checkout(contentId: number): Observable<IHooplaItem> {
    return this._apiService.get(`${this._hooplaUrl}/${contentId}/checkout`);
  }

  earlyReturn(contentId: number): Observable<void> {
    return this._apiService.delete(`${this._hooplaUrl}/${contentId}/earlyreturn`);
  }

  getItem(contentId: string): Observable<IHooplaItem> {
    return this._apiService.get(`${this._hooplaUrl}/${contentId}/itemrequest`);
  }
}
